import React, { useState, useRef, useEffect } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Messages } from "primereact/messages";
import autenticacaoService from "../services/autenticacaoService";
import { hideProcessing, showProcessing } from "../utils/utils";
import ThemeSwitcher from "../components/ThemeSwitcher";
import { useTheme } from "../contexts/ThemeContext";
import RecuperarSenhaDialog from "../components/RecuperarSenhaDialog";
import "../styles/Login.css";

export default function Login() {
    const [usuario, setUsuario] = useState("");
    const [senha, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [displayRecuperarSenha, setDisplayRecuperarSenha] = useState(false);
    const msgRef = useRef();
    const { theme } = useTheme();
    const [redirectUri, setRedirectUri] = useState("/");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const redirect = params.get("redirect_uri");
        if (redirect) {
            setRedirectUri(decodeURIComponent(redirect));
        }
    }, []);

    const logoSrc = theme === 'dark' 
        ? require("../images/logo-dark.png") 
        : require("../images/logo.png");

    const handleUsuarioChange = (e) => {
        setUsuario(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleFormSubmit(e);
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        
        if (!usuario || !senha) {
            msgRef.current.show({
                closable: false,
                severity: "warn",
                summary: "Aviso",
                detail: "Por favor, preencha todos os campos",
            });
            return;
        }

        setLoading(true);
        showProcessing();

        const authRequest = {
            username: usuario,
            password: senha,
        };

        try {
            const response = await autenticacaoService.entrar(authRequest);

            if (response.status === 200) {
                var usuarioAutenticado = response.data;

                localStorage.setItem(
                    "authorizationWGSolJwtToken",
                    usuarioAutenticado.tokenJWT
                );
                localStorage.setItem("usuarioWGSol", JSON.stringify(usuarioAutenticado));
                hideProcessing();
                setLoading(false);
                window.location.href = redirectUri;
            }

            hideProcessing();
            setLoading(false);
        } catch (e) {
            hideProcessing();
            setLoading(false);

            if (e.response !== undefined) {
                msgRef.current.show({
                    closable: false,
                    severity: "error",
                    summary: "Erro",
                    detail: e.response.data || "Erro ao autenticar",
                });
            } else {
                msgRef.current.show({
                    closable: false,
                    severity: "error",
                    summary: "Erro",
                    detail: "Servidor indisponível",
                });
            }
        }
    };

    return (
        <div className="login-container">
            <div className="login-theme-switcher">
                <ThemeSwitcher />
            </div>
            <div className="login-wrapper">
                <Messages ref={msgRef} className="login-messages" />
                
                <Card className="login-card">
                    <div className="login-header">
                        <img src={logoSrc} alt="WGSol Logo" className="login-logo" style={{ width: "80%", borderRadius: "13px" }} />
                        <p className="login-subtitle">Gestão de Obras</p>
                    </div>

                    <form onSubmit={handleFormSubmit} className="login-form">
                        <div className="form-group">
                            <label htmlFor="usuario" className="form-label">
                                Usuário
                            </label>
                            <InputText
                                id="usuario"
                                value={usuario}
                                onChange={handleUsuarioChange}
                                onKeyPress={handleKeyPress}
                                placeholder={"Digite seu usuário"}
                                className="form-input"
                                disabled={loading}
                                autoFocus
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="senha" className="form-label">
                                Senha
                            </label>
                            <Password
                                id="senha"
                                value={senha}
                                onChange={handlePasswordChange}
                                onKeyPress={handleKeyPress}
                                placeholder={"Digite sua senha"}
                                inputClassName="form-input"
                                disabled={loading}
                                toggleMask
                                feedback={false}
                            />
                        </div>

                        <Button
                            type="submit"
                            label={"Entrar"}
                            className="login-button"
                            loading={loading}
                            disabled={loading || !usuario || !senha}
                            icon="pi pi-sign-in"
                            iconPos="right"
                        />

                        <div style={{ textAlign: "center", marginTop: "1rem" }}>
                            <Button
                                label="Esqueceu a senha?"
                                className="p-button-link"
                                type="button"
                                onClick={() => setDisplayRecuperarSenha(true)}
                                disabled={loading}
                                style={{ textDecoration: "underline" }}
                            />
                        </div>
                    </form>
                </Card>

                <div className="login-footer">
                    <p className="footer-text">
                        © 2026 WGSol. Todos os direitos reservados.
                    </p>
                </div>

                <RecuperarSenhaDialog
                    visible={displayRecuperarSenha}
                    onHide={() => setDisplayRecuperarSenha(false)}
                />
            </div>
        </div>
    );
}
